import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDzrOTe7aWZV1wXDJR4K7jQKvWJ6dicycM",
  authDomain: "verificationmodule.firebaseapp.com",
  projectId: "verificationmodule",
  storageBucket: "verificationmodule.appspot.com",
  messagingSenderId: "673271489985",
  appId: "1:673271489985:web:61847cbc2ec881290abb40",
  measurementId: "G-7F4NRH28RY"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
const db = getFirestore(app)

export {app,db};